import classnames from 'classnames';
import { ScheduledQuotesBlotterFilter } from 'components/shared/ScheduledRun/Blotter/filter/Filter';
import { ScheduledQuotesBlotterGrid } from 'components/shared/ScheduledRun/Blotter/grid/ScheduledQuotesBlotterGrid';
import { ConnectedScheduledQuotesBlotterPanel } from 'components/shared/ScheduledRun/Blotter/panel/ScheduledQuotesBlotterPanel';
import { FC } from 'react';

import type { ScheduledQuotesBlotterProps } from './ScheduledQuotesBlotter.connect';
import { connectScheduledQuotesBlotter } from './ScheduledQuotesBlotter.connect';

export const ScheduledQuotesBlotterComponent: FC<ScheduledQuotesBlotterProps> = ({ isBlotterPanelActive }) => {
  return (
    <div className="container-fluid px-0 h-100" data-e2e="scheduled-quotes-blotter-container">
      <div className="d-flex flex-column h-100">
        <ScheduledQuotesBlotterFilter
          className="py-3 px-4"
          searchPlaceholder="scheduleBlotter.filter.placeholder.quickSearch"
        />
        <div className="d-flex flex-grow-1 flex-row min-h-0">
          <div
            className={classnames(
              'd-flex flex-column p-0',
              isBlotterPanelActive ? 'col-lg-8 col-xl-9 col-xxl-9' : 'col-12',
            )}
          >
            <ScheduledQuotesBlotterGrid />
          </div>
          {isBlotterPanelActive && (
            <div className="col-lg-4 col-xl-3 col-xxl-3 px-0">
              <ConnectedScheduledQuotesBlotterPanel />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export const ConnectedScheduledQuotesBlotter = connectScheduledQuotesBlotter(ScheduledQuotesBlotterComponent);
